import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerReceiptService = {
  async getPaymentMethods(select) {
    const getPaymentMethods = {
      url: "api/PaymentMethod",
      filter: "Inactive eq 'N'",
      select: select ? select : undefined,
    };

    return await ApiService.oDataGet(getPaymentMethods);
  },
  async cancelReceipt(payload) {
    var url = `api/CashReceipt/Cancel`;
    return await ApiService.post(url, payload);
  },
  async getCurrentAccountingPeriodCode() {
    const getCurrentAccountingPeriodCode = {
      url: "api/ARFactor",
      select: ["Code", "AccountingPeriodCode"],
    };
    return await ApiService.oDataGet(getCurrentAccountingPeriodCode);
  },
  async getCurrentAccountingPeriod(periodCode) {
    const getCurrentAccountingPeriod = {
      url: "api/AccountingPeriod",
      filter: `Code eq '${periodCode}'`,
      select: ["Code", "DateStart", "DateEnd"],
    };
    return await ApiService.oDataGet(getCurrentAccountingPeriod);
  },

  async getActiveAccountingPeriodStartDate(select) {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AR'`,
      orderby: "StartDate",
      select: select ? select : undefined,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getActiveAccountingPeriodEndDate(select) {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'AR'`,
      orderby: "EndDate desc",
      select: select ? select : undefined,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCreateCustomerReceiptDetail() {
    const getCreateCustomerReceiptDetail = {
      url: "api/CreateCustomerReceiptDetail",
    };
    return await ApiService.oDataGet(getCreateCustomerReceiptDetail);
  },
  async getOutstandingCustomerInvoice(params) {
    const getOutstandingCustomerInvoice = {
      url: "api/OutstandingCustomerInvoice",
      filter: params.filter,
      count: true,
      skip: params.skip,
      top: params.top,
    };
    if (params) {
      if (params.select) {
        getOutstandingCustomerInvoice.select = params.select;
      }
    }
    return await ApiService.oDataGet(getOutstandingCustomerInvoice);
  },
  async saveCustomerReceipt(_payload) {
    var url = "api/Save_CustomerReceipt";
    return await ApiService.post(url, _payload);
  },
  async saveCashinUASalesOrder(payload) {
    return await ApiService.post("api/Save_CashinUASalesOrder", payload);
  },

  async getActiveAccountingPeriodStartAndEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriodStartAndEndDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getCashReceiptDetail(params) {
    const requestScreenData = {
      url: "api/CashReceiptDetail",
      filter: params.filter,
      count: true,
      // skip: params.skip,
      // top: params.top
    };
    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }
    return await ApiService.oDataGet(requestScreenData);
  },
};
export { CustomerReceiptService };
